import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/campaign/actions.js'), 'campaign/actions.js')
  resolveStoreModules(require('../store/campaign/getters.js'), 'campaign/getters.js')
  resolveStoreModules(require('../store/campaign/mutations.js'), 'campaign/mutations.js')
  resolveStoreModules(require('../store/campaign/state.js'), 'campaign/state.js')
  resolveStoreModules(require('../store/languages/verticali.js'), 'languages/verticali.js')
  resolveStoreModules(require('../store/notifications/actions.js'), 'notifications/actions.js')
  resolveStoreModules(require('../store/notifications/getters.js'), 'notifications/getters.js')
  resolveStoreModules(require('../store/notifications/mutations.js'), 'notifications/mutations.js')
  resolveStoreModules(require('../store/notifications/state.js'), 'notifications/state.js')
  resolveStoreModules(require('../store/popup/actions.js'), 'popup/actions.js')
  resolveStoreModules(require('../store/popup/getters.js'), 'popup/getters.js')
  resolveStoreModules(require('../store/popup/mutations.js'), 'popup/mutations.js')
  resolveStoreModules(require('../store/popup/state.js'), 'popup/state.js')
  resolveStoreModules(require('../store/radar/actions.js'), 'radar/actions.js')
  resolveStoreModules(require('../store/radar/getters.js'), 'radar/getters.js')
  resolveStoreModules(require('../store/radar/mutations.js'), 'radar/mutations.js')
  resolveStoreModules(require('../store/radar/state.js'), 'radar/state.js')
  resolveStoreModules(require('../store/site/actions.js'), 'site/actions.js')
  resolveStoreModules(require('../store/site/getters.js'), 'site/getters.js')
  resolveStoreModules(require('../store/site/mutations.js'), 'site/mutations.js')
  resolveStoreModules(require('../store/site/state.js'), 'site/state.js')
  resolveStoreModules(require('../store/smartcv/actions.js'), 'smartcv/actions.js')
  resolveStoreModules(require('../store/smartcv/getters.js'), 'smartcv/getters.js')
  resolveStoreModules(require('../store/smartcv/mutations.js'), 'smartcv/mutations.js')
  resolveStoreModules(require('../store/smartcv/state.js'), 'smartcv/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
